/**
 * Created by Lior Elrom
 * Date: 8/16/16
 * Time: 10:04 AM
 */

'use strict';

const React = require('react');
const ReactDOM = require('react-dom');
const moment = require('moment');
const windowCheck = require('bunsen/helpers/windowCheck');
const { localStorage } = require('dibs-browser-storage');
const enabler = require('../../utils/enabler.es');
const pageTypeHelper = require('../pageTypeHelper.es');
const { PAGE_TYPE } = require('../../constants/pageTypes.es');
const checkoutStorage = require('../../../checkout/helpers/checkout-storage.es');
const makeOfferLauncher = require('../../../contact/offer/helpers/MakeOfferLauncher');

// components
const CheckoutSurvey = require('../../../checkout/containers/CheckoutSurvey');

const abandonCheckoutRule = function abandonCheckoutRule() {
    const isBlacklistedPage = pageTypeHelper.isPageType([PAGE_TYPE.CHECKOUT, PAGE_TYPE.ABOUT]);
    if (isBlacklistedPage || !windowCheck.document) {
        return Promise.resolve();
    }

    const timeUnit = 'minutes';
    const timeValue = 30;
    let checkoutTime;
    let timer;
    let isAfterTimer;

    // checkoutPreAuthOfferModal display logic
    // if checkoutPreAuthOfferModalInfo is present, it overrides checkoutSurveyInfo
    const preAuthOfferModalInfo = localStorage.getItem('checkoutPreAuthOfferModalInfo');
    if (preAuthOfferModalInfo) {
        const {
            itemId,
            offerAmount,
            offerCurrency,
            offerMessage,
            sellerId,
            quantity,
            name
        } = preAuthOfferModalInfo;

        checkoutTime = moment(preAuthOfferModalInfo.checkoutTime);
        timer = checkoutTime.clone().add(timeValue, timeUnit);
        isAfterTimer = moment().isAfter(timer);

        if (!isAfterTimer && !checkoutStorage.getHasSeenPreAuthOfferModal(itemId)) {
            makeOfferLauncher({
                item: {
                    id: itemId,
                    seller: {
                        id: sellerId
                    }
                },
                currency: offerCurrency,
                currentStep: 'abandonMakeOffer',
                preloadedState: {
                    fields: {
                        offerFieldValue: offerAmount,
                        messageFieldValue: offerMessage,
                        nameFieldValue: name,
                        quantityFieldValue: quantity
                    }
                }
            });
            checkoutStorage.setHasSeenPreAuthOfferModal(itemId);
            return Promise.resolve({success: true, type: 'checkoutPreAuthOfferModal'});
        }
    }

    // Old checkout survey
    const isSurveyEnabled = enabler.isEnabled('checkout_survey');
    const surveyInfo = localStorage.getItem('checkoutSurveyInfo');

    if (isSurveyEnabled && surveyInfo && !checkoutStorage.getHasSeenSurvey()) {
        checkoutTime = moment(surveyInfo.checkoutTime);
        timer = checkoutTime.clone().add(timeValue, timeUnit);
        isAfterTimer = moment().isAfter(timer);

        if (!isAfterTimer) {
            const el = windowCheck.document.createElement('div');
            windowCheck.document.body.appendChild(el);
            ReactDOM.render(
                React.createElement(CheckoutSurvey, {}), el
            );
            return Promise.resolve({success: true, type: 'checkoutSurvey'});
        }
    }

    return Promise.resolve();
};

module.exports = abandonCheckoutRule;



// WEBPACK FOOTER //
// ./assets/js/global/notifications/rules/abandonCheckoutRule.es.js